import ScrollMagic from "scrollmagic";
import { TweenMax } from "gsap";
require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");

class RotatingSvgsManager {
  init() {
    this.controller = new ScrollMagic.Controller();
    this.getRotatingSvgsInPage();
    this.scenesArray = [];
  }
  getRotatingSvgsInPage() {
    this.rotatingSvgs = document.querySelectorAll(".rotatingSvg");
  }
  start() {
    this.rotatingSvgs.forEach(svg => {
      const tween = TweenMax.to(svg, 3, { rotation: 80 });
      this.scenesArray = [
        ...this.scenesArray,
        new ScrollMagic.Scene({
          duration: document.body.offsetHeight,
          triggerElement: svg.parentElement
        })
          .setTween(tween)
          .addTo(this.controller)
      ];
    });
  }
  restart() {
    this.cleanUpScenes();
    this.getRotatingSvgsInPage();
    this.start();
  }
  cleanUpScenes() {
    this.scenesArray.forEach(scene => {
      scene.destroy(true);
      scene.remove();
    });
    this.scenesArray = [];
  }
  destroy() {
    if(this.controller){
      this.controller.destroy();
    }
  }
}

export default RotatingSvgsManager;



// WEBPACK FOOTER //
// ./src/managers/RotatingSvgsManager.js